import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Row, Content } from '../components/Layout.js'
import Hero from '../components/Hero'
import Footer from '../components/Footer'
import Carousel from '../components/Carousel'
import Article from '../components/Article'
import Card from '../components/Card'
import Client from '../components/Client'

const heroOptions = {
  header: 'Life<br>@bronzelabs.',
  subtext:
    'Our mission is to continually adopt new and innovative technologies to build something better in a world that’s becoming ever reliant on data and connectivity.',
  background: 'bronzelife'
}

const cards = [
  {
    icon: 'ac-graduation-hat',
    header: 'Careers.',
    text:
      'We’re always looking for talented, versatile and passionate people itching to bring their ideas into the universe.',
    url: '/careers'
  },
  {
    icon: 'ac-bulb-on',
    header: 'Solutions.',
    text:
      'Helping companies quickly implement solutions to the hardest problems they face.',
    url: '/solutions'
  }
]

let currentYear

class About extends Component {
  componentWillMount () {
    this.props.setModal(false)
  }
  yearHeader (year) {
    if (currentYear !== year) {
      currentYear = year
      return <h3>{year}</h3>
    }
  }

  render () {
    const awards = this.props.awards.sort((a, b) => a.year < b.year)
    const { news, clients } = this.props

    return (
      <div className='mainContainer'>
        <Hero options={heroOptions} />

        <section id='questions' className='noTopPadding'>
          <Row>
            <Content>
              <h2>Questions?</h2>
            </Content>
          </Row>
          <Row>
            <Content>
              <h3>What kind of company are you?</h3>
            </Content>
            <Content>
              <span>
                We are an innovation company with big data at the heart of it.
                We do not define ourselves as app, software developers or
                designers, but one that takes those skills onboard to deliver
                something unique and innovative. Our clients can rely on our
                vision and strategy to help build something better in a world
                that’s becoming ever reliant on data and connectivity.
              </span>
            </Content>
          </Row>
          <Row>
            <Content>
              <h3>How are you different?</h3>
            </Content>
            <Content>
              <span>
                <strong>We always keep the end user in mind. </strong>
                We strive to help users grasp, process and understand the
                technology they are using and will build something unique and
                innovative.
              </span>
              <p>
                <strong>We use short, Agile work cycles. </strong>
                They allow us to see a clear breakdown of what is needed and
                when it’s needed for. This prevents a job being rushed and
                cluttered.
              </p>
              <p>
                <strong>We think outside the box. </strong>
                If it’s not innovative then we haven’t succeeded in delivering
                something wonderful.
              </p>
            </Content>
          </Row>
          <Row>
            <Content>
              <h3>Why should I work with you?</h3>
            </Content>
            <Content>
              <span>
                We are a proven, multi-award winning UK based innovative
                technologies firm who have a track record for delivering highly
                skilled, well-thought projects to life that benefit the client,
                the end user and the world around us.
              </span>
            </Content>
          </Row>
        </section>

        <section id='manifesto' className='alternate'>
          <div className='backgroundHex' />
          <div className='backgroundHex' />
          <Row>
            <Content />
            <Content>
              <h2>Our manifesto.</h2>
            </Content>
          </Row>
          <Row>
            <Content classes={['verticalPadding']}>
              <span className='hash'>&#35;</span>
              <span className='list-number'>1</span>
            </Content>
            <Content>
              <p>
                <strong>We care. </strong>
                We put our hearts and souls into making every project we
                undertake the very best it can possibly be and we don’t stop
                until we get there. We care about what we do. Each pixel
                refined, every line of code considered.
              </p>
            </Content>
          </Row>
          <Row>
            <Content>
              <p>
                <strong>Mistakes lead to success. </strong>
                Anything truly new and innovative is by definition
                unpredictable. So to jump in at the deep end and make a lot of
                mistakes, to experiment, play and prototype, is the only way to
                avoid failure in the long run. We have the tools, methods and
                techniques and not least - the attitude - it takes to facilitate
                a process like this and come out with a result that adds value.
              </p>
            </Content>
            <Content classes={['verticalPadding']}>
              <span className='hash'>&#35;</span>
              <span className='list-number'>2</span>
            </Content>
          </Row>
          <Row>
            <Content classes={['verticalPadding']}>
              <span className='hash'>&#35;</span>
              <span className='list-number'>3</span>
            </Content>
            <Content>
              <p>
                <strong>Our culture beats our strategy. </strong>
                Our work is only made possible through close co-operation and
                trust between every single member of our team. That’s why we
                won’t grow faster than we’re able to grow our strong culture and
                collaborative spirit.
              </p>
            </Content>
          </Row>
          <Row>
            <Content>
              <p>
                <strong>Values and trust. </strong>
                Strong, positive relationships that are open and honest are a
                big part of what differentiates us from others. We recognise the
                hardest thing to do within our industry is to build trust, but
                if it exists, you can accomplish so much more and so to this end
                our company and staff will always go the extra mile to earn your
                lasting trust.
              </p>
            </Content>
            <Content classes={['verticalPadding']}>
              <span className='hash'>&#35;</span>
              <span className='list-number'>4</span>
            </Content>
          </Row>
          <Row>
            <Content classes={['verticalPadding']}>
              <span className='hash'>&#35;</span>
              <span className='list-number'>5</span>
            </Content>
            <Content>
              <p>
                <strong>
                  We work in an <i>Agile</i> way.{' '}
                </strong>
                Technology is in constant flux, and everything starts all over
                again the very minute it’s finished. To make those fluctuations
                as small as possible, we keep adjusting in small increments, and
                never lose touch with the real world.
              </p>
            </Content>
          </Row>
        </section>

        <section id='news'>
          <Row>
            <Content>
              <h2>In the news.</h2>
            </Content>
          </Row>
          {news && news.length > 0 && (
            <Carousel>
              {news.map(({ title, subtext, image, url }, index) => (
                <Article
                  title={title}
                  subtext={subtext}
                  image={image}
                  key={index}
                  url={url}
                />
              ))}
            </Carousel>
          )}
        </section>

        <section
          id='clients_and_awards'
          className='half noVerticalPadding alternate'
        >
          <div className='backgroundHex' />
          <div className='backgroundHex' />
          <div className='half' id='clients'>
            <Content classes={['floatRight', 'noPadding']}>
              <Row>
                <Content>
                  <h2>Clients.</h2>
                </Content>
              </Row>
              <Row>
                <Content>
                  <span>
                    We work with world-renowned companies to create awesome
                    software & innovative products.
                  </span>
                  {clients.map((logo, index) => (
                    <Client logo={logo} key={index} />
                  ))}
                </Content>
              </Row>
            </Content>
          </div>
          <div className='half' id='awards'>
            <Content classes={['floatLeft', 'noPadding']}>
              <Row>
                <Content>
                  <h2>Awards.</h2>
                </Content>
              </Row>
              <Row>
                <Content>
                  {awards.map(({ year, name, awarder }, index) => (
                    <span key={index}>
                      {this.yearHeader(year)}
                      <p>
                        {name}
                        <br />
                        <strong>{awarder}</strong>
                      </p>
                    </span>
                  ))}
                </Content>
              </Row>
            </Content>
          </div>
        </section>

        <section id='links'>
          <Row>
            {cards.map((card, index) => (
              <Content key={index}>
                <Card options={card} />
              </Content>
            ))}
          </Row>
        </section>
        <Footer />
      </div>
    )
  }
}

About.propTypes = {
  setModal: PropTypes.func.isRequired,
  awards: PropTypes.arrayOf(PropTypes.object).isRequired,
  news: PropTypes.arrayOf(PropTypes.object).isRequired,
  clients: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default About



// WEBPACK FOOTER //
// ./src/containers/About.js